import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from "./store";

import $ from 'jquery';
window.jQuery = $;
window.$ = $;
// import './assets/style/juhe.css'

//适配
import "../src/config/rem.js";
//存储挂载到原型，通过this调用
import local from "./lib/local"
Vue.prototype.local = local

Vue.config.productionTip = false
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
